var swatchMapByFilter = {};
var vtColorMap = {};
var vtColorMapReady = false;

function parseVariantTableColorMap(wrapper) {
  var colorScript = wrapper.querySelector('.variant-table-color-map');
  if (!colorScript) return;

  try {
    var colors = JSON.parse(colorScript.textContent).colors || [];
    colors.forEach(function (entry) {
      if (!entry || !entry.label) return;
      var normalized = normalizeVariantTableValue(entry.label);
      if (!normalized) return;
      if (!vtColorMap[normalized]) {
        vtColorMap[normalized] = {
          color: String(entry.color || '').trim(),
          image: String(entry.image || '').trim()
        };
      }
    });
    vtColorMapReady = true;
  } catch (error) {
    console.warn('Variant table color map JSON parse failed:', error);
  }
}

function initVariantTableSection(sectionEl) {
  if (!sectionEl || sectionEl.dataset.vtInit) return;
  sectionEl.dataset.vtInit = 'true';

  var wrapper = sectionEl.querySelector('.variant-table-wrapper') || sectionEl;
  var isAsync = wrapper.dataset.async === 'true';
  var dataScript = wrapper.querySelector('.variant-table-data');
  var childHandleScript = wrapper.querySelector('.variant-table-child-handles');
  var rawVariants = [];
  var childHandles = [];

  parseVariantTableColorMap(wrapper);

  if (dataScript) {
    try {
      rawVariants = JSON.parse(dataScript.textContent).variants || [];
    } catch (error) {
      console.warn('Variant table JSON parse failed:', error);
      return;
    }
  }

  if (childHandleScript) {
    try {
      childHandles = JSON.parse(childHandleScript.textContent).handles || [];
    } catch (error) {
      console.warn('Variant table child handles JSON parse failed:', error);
    }
  }

  if (isAsync) {
    startVariantTable(wrapper, rawVariants);
    setTimeout(function () {
      loadVariantsAsync(wrapper, rawVariants, childHandles, function (variants) {
        if (typeof wrapper.variantTableUpdate === 'function') {
          wrapper.variantTableUpdate(variants);
        }
      });
    }, 0);
    return;
  }

  if (!dataScript) return;

  startVariantTable(wrapper, rawVariants);
}

function mergeVariantRecords(existingVariants, newVariants) {
  var seen = {};
  var merged = [];

  (existingVariants || []).concat(newVariants || []).forEach(function (variant) {
    var id = String(variant && variant.id || '');
    if (id && seen[id]) return;

    if (id) seen[id] = true;
    merged.push(variant);
  });

  return merged;
}

function updateVariantLoadCount(wrapper, loaded, total, complete) {
  var totalPending = wrapper.dataset.totalPending === 'true' && !complete;
  var totalCount = parseInt(total, 10) || parseInt(wrapper.dataset.variantCount, 10) || loaded || 0;
  $(wrapper).find('.variant-table__loaded-count').text(totalPending ? (loaded || 0) : Math.min(loaded || 0, totalCount));
  $(wrapper).find('.variant-table__loaded-count-complete').text(totalCount);
  $(wrapper).find('.variant-table__count-loading').toggleClass('hidden', !!complete);
}

function decodeHtmlEntities(value) {
  if (!value) return '';

  var textarea = document.createElement('textarea');
  textarea.innerHTML = value;
  return textarea.value;
}

function getVariantTableSwatch(option) {
  if (!option) return null;

  var image = String(option.color_image || '').trim();
  var color = String(option.color_value || '').trim();

  if (!image && !color && vtColorMapReady) {
    var mapEntry = vtColorMap[normalizeVariantTableValue(option.value || '')];
    if (mapEntry && (mapEntry.image || mapEntry.color)) {
      image = mapEntry.image;
      color = mapEntry.color;
    }
  }

  if (!image) {
    var colorLooksRenderable = /^#|^rgb\(|^rgba\(|^hsl\(|^hsla\(|^[a-z]+$/i.test(color);
    if (!colorLooksRenderable) color = '';
  }

  if (!image && !color) return null;

  return {
    color: color,
    image: image
  };
}

function normalizeVariantTableValue(value) {
  return decodeHtmlEntities(value)
    .replace(/[“”]/g, '"')
    .replace(/[‘’]/g, "'")
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
}

function getVariantOptionValue(variant, normalizedOptionName, fallbackKey) {
  var val = null;

  (variant.options || []).some(function (option) {
    if (String(option.key || '').toLowerCase() === normalizedOptionName) {
      val = option.value;
      return true;
    }

    return false;
  });

  if (val == null && variant.sort_keys && variant.sort_keys[fallbackKey] != null) {
    val = variant.sort_keys[fallbackKey];
  }

  return val;
}

function loadVariantsAsync(wrapper, initialVariants, childHandles, callback) {
  var sectionId = wrapper.dataset.sectionId;
  var totalCount = parseInt(wrapper.dataset.variantCount, 10) || 0;
  var $loading = $(wrapper).find('.variant-table__loading');
  var $progress = $loading.find('.variant-table__loading-progress');
  var $loadingText = $loading.find('.variant-table__loading-text');
  var allVariants = [];
  var loadedVariantIds = {};
  var loadedCount = 0;
  var maxRetries = 3;
  var maxConcurrentRequests = 4;
  var hasError = false;

  if (!sectionId || !childHandles || !childHandles.length) {
    finishLoading(false);
    return;
  }

  function updateProgress() {
    $progress.text(totalCount ? Math.min(loadedCount, totalCount) : loadedCount);
    updateVariantLoadCount(wrapper, loadedCount, totalCount);
  }

  function fetchBatch(handle, attempt) {
    var url = '/products/' + encodeURIComponent(handle) + '?section_id=' + encodeURIComponent(sectionId);

    return fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status + ' at ' + handle);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var script = doc.querySelector('.variant-table-data');
        if (!script) throw new Error('No variant data in response at ' + handle);

        try {
          var data = JSON.parse(script.textContent);
          return data.variants || [];
        } catch (parseError) {
          console.warn('Variant table JSON at ' + handle + ':', parseError.message, script.textContent.slice(0, 200));
          throw new Error('Invalid JSON at ' + handle + ': ' + parseError.message);
        }
      })
      .catch(function (error) {
        if (attempt < maxRetries) {
          return new Promise(function (resolve) {
            setTimeout(resolve, 500 * attempt);
          }).then(function () {
            return fetchBatch(handle, attempt + 1);
          });
        }
        throw error;
      });
  }

  function finishLoading(hasError) {
    $loading.addClass('hidden');
    $(wrapper).find('.variant-table').removeClass('variant-table--loading');

    if (hasError && allVariants.length === 0) {
      $loading.removeClass('hidden');
      $loading.find('.variant-table__loading-spinner').addClass('hidden');
      $loadingText.text('Failed to load variants. Please refresh the page.');
      $(wrapper).find('.variant-table__search-input, .variant-table__filter-select').prop('disabled', true);
      return;
    }

    if (hasError) {
      console.warn('Variant table: partial load — ' + allVariants.length + ' of ' + totalCount + ' variants loaded.');
      callback(allVariants);
      $(wrapper).find('.variant-table__search-input, .variant-table__filter-select').prop('disabled', true);
      return;
    }

    if (!hasError && childHandles && childHandles.length && wrapper.dataset.totalPending === 'true') {
      totalCount = allVariants.length;
      wrapper.dataset.variantCount = String(totalCount);
      wrapper.dataset.totalPending = 'false';
      updateVariantLoadCount(wrapper, loadedCount, totalCount, true);
    }

    $(wrapper).find('.variant-table__search-input, .variant-table__filter-select').prop('disabled', false);

    callback(allVariants);
  }

  function appendVariants(variants) {
    variants.forEach(function (variant) {
      var id = String(variant.id || '');
      if (id && loadedVariantIds[id]) return;

      if (id) loadedVariantIds[id] = true;
      allVariants.push(variant);
    });
    loadedCount = allVariants.length;
    updateProgress();
  }

  function loadAllBatches() {
    var nextIndex = 0;
    var activeRequests = 0;

    function runNext() {
      if (nextIndex >= childHandles.length && activeRequests === 0) {
        finishLoading(hasError);
        return;
      }

      while (activeRequests < maxConcurrentRequests && nextIndex < childHandles.length) {
        var handle = childHandles[nextIndex];
        nextIndex += 1;
        activeRequests += 1;

        fetchBatch(handle, 1)
          .then(appendVariants)
          .catch(function (error) {
            hasError = true;
            console.warn('Variant table async load error:', error);
          })
          .finally(function () {
            activeRequests -= 1;
            runNext();
          });
      }
    }

    runNext();
  }

  if (initialVariants && initialVariants.length) {
    appendVariants(initialVariants);
  }

  loadAllBatches();
}

function populateFiltersFromVariants($wrapper, rawVariants) {
  if (!rawVariants || !rawVariants.length) return;

  var swatchMapByOption = {};

  rawVariants.forEach(function (variant) {
    (variant.options || []).forEach(function (option) {
      var optionKey = String(option.key || '').toLowerCase();
      var optionValue = normalizeVariantTableValue(option.value || '');
      var swatch = getVariantTableSwatch(option);

      if (!optionKey || !optionValue || !swatch) return;
      if (!swatchMapByOption[optionKey]) swatchMapByOption[optionKey] = {};
      if (!swatchMapByOption[optionKey][optionValue]) {
        swatchMapByOption[optionKey][optionValue] = swatch;
      }
    });
  });

  $wrapper.find('.variant-table__filter-select').each(function () {
    var $select = $(this);
    var optionName = $select.data('option-name');
    var normalizedOptionName = String(optionName).toLowerCase().replace(/\s+/g, '-');
    var key = 'option-' + normalizedOptionName;
    var valueMap = {};

    $select.find('option:not([value=""])').each(function () {
      var val = String(this.value || '').trim();
      if (val) valueMap[normalizeVariantTableValue(val)] = val;
    });

    var filterSwatchMap = {};
    rawVariants.forEach(function (variant) {
      var val = getVariantOptionValue(variant, normalizedOptionName, key);

      if (val != null && String(val).trim() !== '') {
        var normalizedValue = normalizeVariantTableValue(val);
        valueMap[normalizedValue] = String(val).trim();

        if (!filterSwatchMap[normalizedValue]) {
          (variant.options || []).some(function (option) {
            if (String(option.key || '').toLowerCase() !== normalizedOptionName) return false;
            var swatch = getVariantTableSwatch(option);
            if (!swatch && swatchMapByOption[normalizedOptionName]) {
              swatch = swatchMapByOption[normalizedOptionName][normalizedValue] || null;
            }
            if (swatch) filterSwatchMap[normalizedValue] = swatch;
            return true;
          });
        }
      }
    });
    swatchMapByFilter[normalizedOptionName] = filterSwatchMap;

    var sorted = Object.keys(valueMap).map(function (normalizedValue) {
      return valueMap[normalizedValue];
    }).sort(function (a, b) {
      return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
    });

    if (!sorted.length) return;

    var currentVal = $select.val();
    $select.find('option:not([value=""])').remove();
    sorted.forEach(function (val) {
      $select.append($('<option>').attr('value', val).text(val));
    });
    if (currentVal && valueMap[normalizeVariantTableValue(currentVal)]) {
      $select.val(currentVal);
    }
  });
}

var vtLightboxLastTrigger = null;
var vtLightboxLoadToken = 0;

function ensureVariantTableLightbox() {
  var lightbox = document.querySelector('.vt-lightbox');
  if (lightbox) return lightbox;

  lightbox = document.createElement('div');
  lightbox.className = 'vt-lightbox';
  lightbox.setAttribute('role', 'dialog');
  lightbox.setAttribute('aria-modal', 'true');
  lightbox.setAttribute('aria-label', 'Product image zoom');
  lightbox.innerHTML =
    '<button type="button" class="vt-lightbox__close" aria-label="Close">' +
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" width="20" height="20" fill="none" aria-hidden="true">' +
    '<path d="M1 1l16 16M17 1L1 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
    '</svg></button>' +
    '<span class="vt-lightbox__spinner" aria-hidden="true"></span>' +
    '<img class="vt-lightbox__image" alt="">';
  document.body.appendChild(lightbox);

  lightbox.addEventListener('click', function (event) {
    if (event.target === lightbox) closeVariantTableLightbox();
  });
  lightbox.querySelector('.vt-lightbox__close').addEventListener('click', closeVariantTableLightbox);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeVariantTableLightbox();
  });

  return lightbox;
}

function openVariantTableLightbox(src, trigger) {
  if (!src) return;
  var lightbox = ensureVariantTableLightbox();
  var img = lightbox.querySelector('.vt-lightbox__image');

  vtLightboxLastTrigger = trigger || null;

  img.removeAttribute('src');
  img.alt = '';
  lightbox.classList.remove('has-image');
  lightbox.classList.add('is-open');
  document.body.style.overflow = 'hidden';
  lightbox.querySelector('.vt-lightbox__close').focus();

  var token = ++vtLightboxLoadToken;
  var loader = new Image();
  loader.onload = function () {
    if (token !== vtLightboxLoadToken || !lightbox.classList.contains('is-open')) return;
    var thumbImg = vtLightboxLastTrigger ? vtLightboxLastTrigger.querySelector('img') : null;
    img.src = src;
    img.alt = thumbImg ? thumbImg.alt : '';
    lightbox.classList.add('has-image');
  };
  loader.onerror = function () {
    if (token !== vtLightboxLoadToken || !lightbox.classList.contains('is-open')) return;
  };
  loader.src = src;
}

function closeVariantTableLightbox() {
  var lightbox = document.querySelector('.vt-lightbox');
  if (!lightbox || !lightbox.classList.contains('is-open')) return;
  lightbox.classList.remove('is-open');
  document.body.style.overflow = '';
  if (vtLightboxLastTrigger && document.contains(vtLightboxLastTrigger)) {
    vtLightboxLastTrigger.focus();
  }
  vtLightboxLastTrigger = null;
}

function startVariantTable(wrapper, rawVariants) {
  var $wrapper = $(wrapper);
  var $search = $wrapper.find('.variant-table__search-input');
  var $filterSelects = $wrapper.find('.variant-table__filter-select');
  var $noResults = $wrapper.find('.variant-table__no-results');
  var $loadMore = $wrapper.find('.variant-table__load-more');
  var $tbody = $wrapper.find('.variant-table tbody');
  var metafieldColumnLabels = [];
  var rowLimit = 50;
  var visibleCount = 0;
  var filteredVariants = [];
  var sortState = { key: '', dir: null };
  var isAsync = wrapper.dataset.async === 'true';
  var swatchMapByOption = {};

  function setFiltersDisabled(disabled) {
    $filterSelects.prop('disabled', disabled);
    $search.prop('disabled', disabled);
  }

  function buildSwatchMap() {
    swatchMapByOption = {};

    rawVariants.forEach(function (variant) {
      (variant.options || []).forEach(function (option) {
        var optionKey = String(option.key || '').toLowerCase();
        var optionValue = normalizeVariantTableValue(option.value || '');
        var swatch = getVariantTableSwatch(option);

        if (!optionKey || !optionValue || !swatch) return;
        if (!swatchMapByOption[optionKey]) swatchMapByOption[optionKey] = {};
        if (!swatchMapByOption[optionKey][optionValue]) {
          swatchMapByOption[optionKey][optionValue] = swatch;
        }
      });
    });
  }

  function getResolvedOptionSwatch(option) {
    var swatch = getVariantTableSwatch(option);
    if (swatch) return swatch;

    var optionKey = String(option && option.key || '').toLowerCase();
    var optionValue = normalizeVariantTableValue(option && option.value || '');
    swatch = optionKey && optionValue && swatchMapByOption[optionKey]
      ? swatchMapByOption[optionKey][optionValue] || null
      : null;

    return swatch;
  }

  function normalizeOptionKey(name) {
    return String(name).toLowerCase().replace(/\s+/g, '-');
  }

  function escapeHtml(string) {
    return String(string)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function createFilterSwatchFormatter(filterName) {
    return function (data) {
      var text = escapeHtml(data.text || '');
      var filterSwatches = swatchMapByFilter[filterName] || {};
      var swatch = filterSwatches[normalizeVariantTableValue(data.text || data.id || '')];
      if (!swatch || (!swatch.color && !swatch.image)) return text;
      var style = swatch.image
        ? 'background-image:url(' + escapeHtml(swatch.image) + ');background-size:cover;background-position:center;'
        : 'background-color:' + escapeHtml(swatch.color) + ';';
      return '<span class="variant-table__filter-swatch" style="' + style + '"></span>' + text;
    };
  }

  function initSelect2Filters() {
    var useSelect2 = window.jQuery && jQuery.fn && jQuery.fn.select2 && wrapper.dataset.filterStyle !== 'native';
    $filterSelects.each(function () {
      var $select = $(this);
      if ($select.data('select2')) $select.select2('destroy');
      if (!useSelect2) return;
      var filterName = String($select.data('option-name') || '').toLowerCase().replace(/\s+/g, '-');
      $select.select2({
        width: '100%',
        minimumResultsForSearch: 8,
        escapeMarkup: function (markup) { return markup; },
        templateResult: createFilterSwatchFormatter(filterName),
        templateSelection: createFilterSwatchFormatter(filterName)
      });
    });
  }

  function refreshSelect2Filters() {
    $filterSelects.each(function () {
      var $select = $(this);
      if ($select.data('select2')) $select.select2('destroy');
    });
    initSelect2Filters();
  }

  function getSortValue(variant, key) {
    if (!key) return '';
    if (variant.sort_keys && variant.sort_keys[key] != null) {
      return String(variant.sort_keys[key]).toLowerCase();
    }
    return String(variant[key] || '').toLowerCase();
  }

  function buildRow(variant, index) {
    var tr = document.createElement('tr');
    tr.className = 'variant-table__row';
    if (!variant.available) tr.classList.add('variant-table__row--unavailable');
    tr.dataset.variantId = variant.id;
    tr.dataset.title = variant.title || '';
    tr.dataset.sku = variant.sku || '';
    tr.dataset.image = variant.image_200 || '';
    tr.dataset.price = variant.price || '';
    tr.dataset.comparePrice = variant.compare_price || '';
    tr.dataset.search = variant.search || '';

    variant.options.forEach(function (option) {
      // Option names like "Finish/Color" produce keys that aren't valid attribute names
      var key = (option.key || '').replace(/[^a-z0-9_-]+/gi, '-');
      if (key) tr.setAttribute('data-option-' + key, option.value || '');
    });

    function createCell(label, content, extraClass) {
      var td = document.createElement('td');
      td.className = 'variant-table__cell' + (extraClass ? ' ' + extraClass : '');
      td.dataset.label = label;
      td.innerHTML = content;
      return td;
    }

    function createTextCell(label, content, extraClass) {
  var td = document.createElement('td');
  td.className = 'variant-table__cell' + (extraClass ? ' ' + extraClass : '');
  td.dataset.label = label;
  td.textContent = content || '';

  if (content && String(content).includes('\n')) {
    td.style.whiteSpace = 'pre-line';
  }

  return td;
}

    tr.appendChild(createTextCell('#', String(index + 1), 'variant-table__cell--number'));
    tr.appendChild(createTextCell('Variant ID', String(variant.id || ''), 'variant-table__cell--variant-id'));

    var imageCell = document.createElement('td');
    imageCell.className = 'variant-table__cell';
    imageCell.dataset.label = 'Image';
    var imageContent = '';
    if (variant.image_80) {
      var fullSrc = variant.image_large || variant.image_200 || '';
      imageContent =
        '<button type="button" class="variant-table__zoom-trigger" data-full-src="' + escapeHtml(fullSrc) + '" aria-label="Zoom product image">' +
        '<img src="' + escapeHtml(variant.image_80) + '" alt="' + escapeHtml(variant.title || '') + '" width="60" height="60" loading="lazy">' +
        '</button>';
    } else {
      var placeholderTpl = wrapper.querySelector('.variant-table__placeholder-image');
      if (placeholderTpl) imageContent = placeholderTpl.innerHTML;
    }
    imageCell.innerHTML = '<div class="variant-table__image">' + imageContent + '</div>';
tr.appendChild(imageCell);

// Part # immediately after Image
tr.appendChild(createCell('Part Number', escapeHtml(variant.sku || '')));

variant.options.forEach(function (option) {
  var optionCell = document.createElement('td');
  optionCell.className = 'variant-table__cell';
  optionCell.dataset.label = option.name || '';
  var optionSwatch = getResolvedOptionSwatch(option);
  if (optionSwatch) {
    var swatchStyle = optionSwatch.image
      ? 'background-image: url(' + escapeHtml(optionSwatch.image) + ');'
      : 'background-color: ' + escapeHtml(optionSwatch.color || '') + ';';
    optionCell.innerHTML = '<span class="variant-table__color-swatch" style="' + swatchStyle + '"></span>' + escapeHtml(option.value || '');
  } else {
    optionCell.textContent = option.value || '';
  }
  tr.appendChild(optionCell);
});

    (metafieldColumnLabels.length ? metafieldColumnLabels : (variant.metafield_columns || []).map(function (column) { return column.label || ''; })).forEach(function (label, columnIndex) {
      var column = (variant.metafield_columns || [])[columnIndex] || {};
      tr.appendChild(createTextCell(label || column.label || '', decodeHtmlEntities(column.value || '')));
    });

    var priceContent = '';
    if (variant.compare_price) {
      priceContent += '<s class="variant-table__compare-price">' + escapeHtml(variant.compare_price) + '</s>';
    }
    priceContent += '<span class="variant-table__current-price">' + escapeHtml(variant.price || '') + '</span>';
    tr.appendChild(createCell('Price', priceContent, 'variant-table__cell--price'));

    var qtyInputHtml =
      '<div class="variant-table__qty">' +
      '<button type="button" class="variant-table__qty-btn variant-table__qty-btn--minus">−</button>' +
      '<input type="number" class="variant-table__qty-input" value="1" min="1"' +
      ((variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny') ? ' max="' + escapeHtml(variant.inventory_quantity || '') + '"' : '') +
      '>' +
      '<button type="button" class="variant-table__qty-btn variant-table__qty-btn--plus">+</button>' +
      '</div>';
    tr.appendChild(createCell('Quantity', qtyInputHtml));

    // custom.request_quote products add to the cart drawer quote list instead of the cart (see addToQuote)
    var isQuote = !!variant.request_quote;
    var addText = isQuote
      ? wrapper.dataset.addToQuoteText || 'Request A Quote'
      : (window.Shopify && Shopify.translation && Shopify.translation.add_to_cart ? Shopify.translation.add_to_cart : 'Add to cart');

    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/cart/add';
    form.className = 'variant-table__form';
    form.innerHTML =
      '<input type="hidden" name="id" value="' + escapeHtml(variant.id || '') + '">' +
      '<input type="hidden" name="quantity" class="vt-qty" value="1">' +
      (variant.sku ? '<input type="hidden" name="properties[Part Number]" value="' + escapeHtml(variant.sku) + '">' : '') +
      '<button type="button" class="variant-table__add-btn' + (isQuote ? ' variant-table__add-btn--quote' : '') + (variant.available ? '' : ' variant-table__add-btn--disabled') + '"' +
      (isQuote ? ' data-quote data-product-url="' + escapeHtml(variant.product_url || '') + '"' : '') +
      (variant.available ? '' : ' disabled') + '>' +
      '<span class="variant-table__add-btn-text">' + escapeHtml(addText) + '</span>' +
      '<div class="loading__spinner hidden"><svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg></div>' +
      '</button>' +
      '<span class="variant-table__error hidden"></span>';

    var actionCell = document.createElement('td');
    actionCell.className = 'variant-table__cell variant-table__cell--action';
    actionCell.dataset.label = '';
    actionCell.appendChild(form);
    tr.appendChild(actionCell);

    return tr;
  }

  function sortVariants(variants) {
    if (!sortState.key || !sortState.dir) return variants.slice();
    return variants.slice().sort(function (a, b) {
      var va = getSortValue(a, sortState.key);
      var vb = getSortValue(b, sortState.key);
      var aNum = numericValue(va);
      var bNum = numericValue(vb);
      if (aNum !== null && bNum !== null && aNum !== bNum) {
        return sortState.dir === 'asc' ? aNum - bNum : bNum - aNum;
      }
      var result = va.localeCompare(vb, undefined, { numeric: true, sensitivity: 'base' });
      return sortState.dir === 'asc' ? result : -result;
    });
  }

  function numericValue(str) {
    var s = String(str).trim();
    var frac = s.match(/^\s*(\d+)\s*\/\s*(\d+)/);
    if (frac) return parseInt(frac[1], 10) / parseInt(frac[2], 10);
    var num = s.match(/(\d+(?:\.\d+)?)/);
    return num ? parseFloat(num[1]) : null;
  }

  function updateControls() {
    var hasMore = visibleCount < filteredVariants.length;
    $loadMore.toggleClass('hidden', !hasMore);
    $noResults.toggleClass('hidden', filteredVariants.length > 0);
  }

  function getVisibleRows() {
    var sorted = sortVariants(filteredVariants);
    return sorted.slice(0, visibleCount).map(function (variant, index) {
      return buildRow(variant, index);
    });
  }

  function renderRows(rows) {
    $tbody.empty();
    rows.forEach(function (row) {
      $tbody.append(row);
    });
  }

  function filterVariants() {
    var search = $.trim(String($search.val() || '').toLowerCase());
    var tokens = search ? search.split(/\s+/) : [];
    var filters = {};

    $filterSelects.each(function () {
      var $select = $(this);
      var val = $.trim(String($select.val() || ''));
      if (val) {
        filters['option-' + normalizeOptionKey($select.data('option-name'))] = normalizeVariantTableValue(val);
      }
    });

    filteredVariants = rawVariants.filter(function (variant) {
      var show = true;
      if (tokens.length) {
        var hay = String(variant.search || '').toLowerCase();
        for (var i = 0; i < tokens.length; i++) {
          if (tokens[i] && hay.indexOf(tokens[i]) === -1) {
            show = false;
            break;
          }
        }
      }
      if (show) {
        for (var key in filters) {
          if (!filters.hasOwnProperty(key)) continue;
          var optionName = key.replace(/^option-/, '');
          var rowVal = normalizeVariantTableValue(getVariantOptionValue(variant, optionName, key) || '');
          if (rowVal !== filters[key]) {
            show = false;
            break;
          }
        }
      }
      return show;
    });

    visibleCount = Math.min(rowLimit, filteredVariants.length);
    renderRows(getVisibleRows());
    updateControls();
  }

  function initializeRows() {
    $wrapper.find('.variant-table thead th.variant-table__th--metafield').each(function () {
      var label = $.trim($(this).text());
      if (label) {
        metafieldColumnLabels.push(label);
      }
    });
    buildSwatchMap();
    populateFiltersFromVariants($wrapper, rawVariants);
    initSelect2Filters();
    filteredVariants = rawVariants.slice();
    visibleCount = Math.min(rowLimit, filteredVariants.length);
    renderRows(getVisibleRows());
    updateVariantLoadCount(wrapper, rawVariants.length, wrapper.dataset.variantCount || rawVariants.length, wrapper.dataset.async !== 'true');
    if (rawVariants.length && !isAsync) {
      $(wrapper).find('.variant-table').removeClass('variant-table--loading');
    }
    setFiltersDisabled(isAsync);
    updateControls();
  }

  wrapper.variantTableUpdate = function (variants) {
    rawVariants = mergeVariantRecords(rawVariants, variants || []);
    $(wrapper).find('.variant-table').removeClass('variant-table--loading');
    buildSwatchMap();
    populateFiltersFromVariants($wrapper, rawVariants);
    refreshSelect2Filters();
    updateVariantLoadCount(wrapper, rawVariants.length, wrapper.dataset.variantCount || rawVariants.length, wrapper.dataset.totalPending !== 'true');
    filterVariants();
  };

  function applySort() {
    var key = this.getAttribute('data-sort-key');
    if (!key) return;
    if (sortState.key !== key) {
      sortState = { key: key, dir: 'asc' };
    } else if (sortState.dir === 'asc') {
      sortState.dir = 'desc';
    } else {
      sortState = { key: '', dir: null };
    }

    $wrapper.find('.variant-table__th--sortable')
      .removeClass('is-sort-asc is-sort-desc')
      .attr('aria-sort', 'none');

    if (sortState.key && sortState.dir) {
      $wrapper.find('.variant-table__th--sortable[data-sort-key="' + sortState.key + '"]')
        .addClass('is-sort-' + sortState.dir)
        .attr('aria-sort', sortState.dir === 'asc' ? 'ascending' : 'descending');
    }

    filterVariants();
  }

  function addToCart(form) {
    var btn = form.querySelector('.variant-table__add-btn');
    if (!btn || btn.disabled || btn.classList.contains('loading')) return;
    btn.disabled = true;
    btn.classList.add('loading');
    var spinner = btn.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (!cart) {
      window.location = '/cart';
      return;
    }

    var body = {
      id: form.querySelector('[name="id"]').value,
      quantity: form.querySelector('.vt-qty').value || 1,
      sections: typeof cart.getSectionsToRender === 'function' ? cart.getSectionsToRender().map(function (s) { return s.id; }) : [],
      sections_url: window.location.pathname,
    };

    var propInput = form.querySelector('[name="properties[Part Number]"]');
    if (propInput && propInput.value) {
      body.properties = { 'Part Number': propInput.value };
    }

    if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function (data) {
        if (data.status) throw data;
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'variant-table', cartData: data });
        }
        if (typeof cart.renderContents === 'function') {
          cart.renderContents(data);
        } else if (typeof cart.open === 'function') {
          cart.open();
        }
        if (cart.classList && cart.classList.contains('is-empty')) {
          cart.classList.remove('is-empty');
        }
      })
      .catch(function (err) {
        console.warn('Variant table add-to-cart error:', err);
        if (err && err.description) showRowError(form, err.description);
      })
      .finally(function () {
        btn.disabled = false;
        btn.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
      });
  }

  // Quote rows: same flow as the PDP Request A Quote button. CartDrawer.requestQuote saves the
  // variant to the quote list (never the cart) and opens the drawer on the Quote tab.
  function addToQuote(form) {
    var btn = form.querySelector('.variant-table__add-btn');
    var drawer = document.querySelector('cart-drawer');
    if (!btn || btn.disabled || btn.classList.contains('loading')) return;
    if (!drawer || typeof drawer.requestQuote !== 'function') return;
    btn.disabled = true;
    btn.classList.add('loading');
    var spinner = btn.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');

    var propInput = form.querySelector('[name="properties[Part Number]"]');
    drawer
      .requestQuote(
        form.querySelector('[name="id"]').value,
        btn,
        propInput ? propInput.value : '',
        parseInt(form.querySelector('.vt-qty').value, 10) || 1
      )
      .then(function (added) {
        if (!added) showRowError(form, (window.cartStrings && cartStrings.error) || 'Could not add to quote.');
      })
      .finally(function () {
        btn.disabled = false;
        btn.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
      });
  }

  function showRowError(form, message) {
    var msg = form.closest('tr').querySelector('.variant-table__error');
    if (!msg) return;
    msg.textContent = message;
    msg.classList.remove('hidden');
    setTimeout(function () { msg.classList.add('hidden'); }, 5000);
  }

  function bindEvents() {
    wrapper.addEventListener('click', function (event) {
      var zoomTrigger = event.target.closest('.variant-table__zoom-trigger');
      if (zoomTrigger && zoomTrigger.dataset.fullSrc) {
        event.preventDefault();
        openVariantTableLightbox(zoomTrigger.dataset.fullSrc, zoomTrigger);
        return;
      }

      var addBtn = event.target.closest('.variant-table__add-btn');
      if (addBtn) {
        event.preventDefault();
        if (addBtn.disabled) return;
        var form = addBtn.closest('.variant-table__form');
        if (form) addBtn.hasAttribute('data-quote') ? addToQuote(form) : addToCart(form);
        return;
      }

      var qtyBtn = event.target.closest('.variant-table__qty-btn');
      if (qtyBtn) {
        var input = qtyBtn.parentElement.querySelector('.variant-table__qty-input');
        if (!input) return;
        var min = parseInt(input.getAttribute('min')) || 1;
        var max = input.getAttribute('max') ? parseInt(input.getAttribute('max')) : null;
        var val = parseInt(input.value) || min;
        var form = qtyBtn.closest('tr').querySelector('.variant-table__form');
        var hiddenQty = form && form.querySelector('.vt-qty');
        if (qtyBtn.classList.contains('variant-table__qty-btn--minus') && val > min) {
          input.value = val - 1;
          if (hiddenQty) hiddenQty.value = input.value;
        } else if (qtyBtn.classList.contains('variant-table__qty-btn--plus') && (max === null || val < max)) {
          input.value = val + 1;
          if (hiddenQty) hiddenQty.value = input.value;
        }
      }
    });

    wrapper.addEventListener('change', function (event) {
      var input = event.target.closest('.variant-table__qty-input');
      if (!input) return;
      var min = parseInt(input.getAttribute('min')) || 1;
      var max = input.getAttribute('max') ? parseInt(input.getAttribute('max')) : null;
      var val = parseInt(input.value) || min;
      if (val < min) val = min;
      if (max !== null && val > max) val = max;
      input.value = val;
      var form = input.closest('tr').querySelector('.variant-table__form');
      var hiddenQty = form && form.querySelector('.vt-qty');
      if (hiddenQty) hiddenQty.value = val;
    });

    $wrapper.on('click', '.variant-table__th--sortable', applySort);
    $search.on('input', filterVariants);
    $filterSelects.on('change', filterVariants);
    $loadMore.on('click', function () {
      visibleCount = Math.min(filteredVariants.length, visibleCount + rowLimit);
      renderRows(getVisibleRows());
      updateControls();
    });
  }

  initializeRows();
  bindEvents();
}

function initVariantTableSections() {
  document.querySelectorAll('.product-variant-table-section').forEach(function (wrapper) {
    initVariantTableSection(wrapper);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVariantTableSections);
} else {
  initVariantTableSections();
}

document.addEventListener('shopify:section:load', function (event) {
  var section = event.target && event.target.querySelector('.product-variant-table-section');
  if (section) initVariantTableSection(section);
});

document.addEventListener('shopify:section:reload', function (event) {
  var section = event.target && event.target.querySelector('.product-variant-table-section');
  if (section) initVariantTableSection(section);
});
